import React, { Fragment } from "react";
import { InputNumber } from "primereact/inputnumber";

const InputFieldInteger = ({
  handler,
  variables: { value, disabled, showError },
  constants: { label, medSize, id, textError, name, minimum, maximum },
}) => {
  return (
    <Fragment>
      <div className={`p-field p-col-4 p-md-${medSize}`}>
        <label htmlFor={id}>{label}</label>
        <InputNumber
          name={name}
          id={id}
          min={minimum}
          max={maximum}
          value={value}
          onValueChange={handler}
          disabled={disabled}
        />
        {showError && (
          <small id={`${id}-help`} className='p-invalid p-d-block'>
            {textError}
          </small>
        )}
      </div>
    </Fragment>
  );
};

export default InputFieldInteger;
